module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IN-43dd36b63223a62c758e98c0614d1631.png";